import { jsxs as w, jsx as c } from "react/jsx-runtime";
import g, { forwardRef as S, useState as b, useRef as C, useEffect as x } from "react";
import { a as k, b as A, _ as N } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import a from "styled-components";
import { R as q, I as _ } from "../chunks/index.cff5baaf.js";
const E = a.div.withConfig({
  displayName: "Accordion",
  componentId: "sc-14gq7h5-0"
})(['& *{margin:0;padding:0;}position:relative;width:100%;display:flex;flex-direction:column;border-radius:var(--default-border-radius);border:var(--default-border-width) solid var(--elements-border-color);transition-property:background-color;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);[role="heading"]{border-radius:inherit;}&:hover:not([data-expanded="true"]){border-color:transparent;}']), G = a.button.withConfig({
  displayName: "Trigger",
  componentId: "sc-14gq7h5-1"
})(['background-color:transparent;position:relative;width:-webkit-fill-available;height:var(--size-10x);padding:0 var(--spacing-3x);border-radius:inherit;cursor:pointer;outline:none;border:none;display:flex;justify-content:space-between;align-items:center;gap:var(--spacing-2x);transition-property:background-color;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);&:hover:not([aria-expanded="true"]){', " transition-timing-function:var(--curve-productive-entrance);}&:focus-visible{", " outline-offset:2px;}"], k, A), P = a.span.withConfig({
  displayName: "Title",
  componentId: "sc-14gq7h5-2"
})(["", " color:var(--text-label-color);position:relative;line-height:var(--line-height-sm);width:100%;box-sizing:border-box;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-align:left;"], N), j = a.span.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-14gq7h5-3"
})([""]), z = a.div.withConfig({
  displayName: "PanelContainer",
  componentId: "sc-14gq7h5-4"
})(['position:relative;overflow:hidden;opacity:1;height:fit-content;transition-property:height,opacity;transform-origin:center top;transition-timing-function:var(--curve-productive-entrance);transition-duration:var(--duration-fast-02);&[data-hidden="true"]{height:0;opacity:0;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);}']), M = a.section.withConfig({
  displayName: "Panel",
  componentId: "sc-14gq7h5-5"
})(["position:relative;padding:0 var(--spacing-3x) var(--spacing-3x);"]), O = S(({
  children: p,
  expanded: i = !1,
  label: d = "",
  index: s,
  headingLevel: h = 3,
  id: u,
  onClick: r,
  ...v
}, m) => {
  const [t, n] = b(!!i), o = C(!!i), e = C(null), [l, y] = b(0);
  x(() => {
    i !== o.current && (n(i), o.current = i);
  }, [i, o.current]), x(() => {
    y(t ? e.current.clientHeight : 0);
  }, [t, p]);
  const I = (R) => {
    n(!t), r && r(R);
  };
  return /* @__PURE__ */ w(E, { "data-expanded": t, children: [
    g.createElement(`h${h}`, {
      role: "heading"
    }, /* @__PURE__ */ w(G, { type: "button", "aria-expanded": t, "aria-controls": `sect${s}`, id: u, ...v, onClick: I, ref: m, "data-rango-component": "rango-accordion", "data-is-rango": !0, children: [
      /* @__PURE__ */ c(P, { children: d }),
      /* @__PURE__ */ c(j, { "data-expanded": t, children: /* @__PURE__ */ c(q, { size: _.MD, icon: t ? "DropdownCloseLine" : "DropdownOpenLine" }) })
    ] })),
    /* @__PURE__ */ c(z, { "data-hidden": !t, style: {
      height: `${l}px`
    }, children: /* @__PURE__ */ c(M, { id: `sect${s}`, "aria-labelledby": u, ref: e, children: p }) })
  ] });
});
O.displayName = "RangoAccordion";
const T = a.div.withConfig({
  displayName: "AccordionGroup",
  componentId: "sc-qt7y6i-0"
})(["position:relative;display:grid;width:100%;gap:var(--spacing-2x);"]), f = {
  Single: "single",
  Multiple: "multiple"
};
Object.values(f);
const $ = g.forwardRef(({
  children: p,
  mode: i = f.Single,
  expandedIndexes: d = [],
  onExpandedIndexesChange: s,
  ...h
}, u) => {
  const [r, v] = b(d);
  x(() => {
    r !== d && s && s(r);
  }, [r, d]);
  const m = (n, o) => {
    let e = r;
    o ? i === f.Single ? e = [] : e = e.filter((l) => l !== n) : i === f.Single ? e = [n] : e = [...e, n], v(e);
  };
  return /* @__PURE__ */ c(T, { ...h, ref: u, children: (() => g.Children.map(p, (n) => {
    const o = n.props, e = r.indexOf(o.index) !== -1, l = {
      ...o,
      onClick: () => m(o.index, e),
      expanded: e ? !0 : void 0
    };
    return [g.cloneElement(n, l)];
  }))() });
});
$.displayName = "RangoAccordionGroup";
export {
  f as AccordionGroupMode,
  O as RangoAccordion,
  $ as RangoAccordionGroup
};
